import { useState } from "react";

const DEFAULT_FORM_DATA = {
  first_name: "",
  last_name: "",
  email: "",
  country: "",
  phone: "",
  message: "",
};

const useContactForm = ({
  endpoint = "https://hypwave.com/email/send-email.php",
  redirectUrl = "https://hypwave.com/thank-you",
  successMessage = "✅ Email sent successfully! Thank you for your submission!",
  recaptchaRequired = true,
  statusClearMs = 10000,
} = {}) => {
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData(DEFAULT_FORM_DATA);
    setCaptchaToken(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (recaptchaRequired && !captchaToken) {
      setStatus("❌ Please verify reCAPTCHA.");
      return;
    }

    setLoading(true);
    setStatus("");

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        body: new URLSearchParams({
          ...formData,
          "g-recaptcha-response": captchaToken || "",
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        setStatus(successMessage);
        resetForm();
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      } else {
        setStatus(`❌ ${result.message}`);
      }
    } catch (error) {
      setStatus("❌ Error sending message.");
    } finally {
      setLoading(false);
      setTimeout(() => setStatus(""), statusClearMs);
    }
  };

  return {
    formData,
    captchaToken,
    loading,
    status,
    handleChange,
    handleSubmit,
    setCaptchaToken,
    resetForm,
  };
};

export default useContactForm;
